import {
  OutlineEmailIconComponent,
  SmartPhoneIconComponent,
  EditIconComponent,
  CopyIconComponent,
} from "assets/icons";
import useTranslation from "hooks/useTranslation";
import { truncate } from "utils/text";
import styles from "./styles.module.scss";

function ContentField({
  type,
  userInfo,
  selectedConversation,
  setEditUserFiled,
  setCopyText,
}) {
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();

  const detailsOnType = {
    email: {
      icon: OutlineEmailIconComponent,
      title: t("EMAIL"),
      inputType: "email",
    },
    phone: {
      icon: SmartPhoneIconComponent,
      title: t("PHONE"),
      inputType: "text",
    },
  };

  const Icon = detailsOnType[type].icon;
  const title = detailsOnType[type].title;

  const handleEditBtnClick = () => {
    setEditUserFiled(type, true);
  };

  const handleCopyBtnClick = () => {
    setCopyText(selectedConversation.user[type] || "");
  };

  return (
    <div className="w-100">
      <div className="conv__userinfo__card__info__fields__inner__row__title no-flex userinfo_item">
        <Icon className={styles.userinfo_icon} />
        {title}
        {" : "}
      </div>
      <div className="flex flex-jc-sb flex-ai-c w-100 flex-columngap-8">
        <div className="conv__userinfo__card__info__fields__inner__row__value w-100 flex flex-jc-s input_styles dir-ltr">
          {truncate(userInfo[type], 26)}
        </div>

        <div className="actions flex flex-ai-c flex-columngap-8">
          <div
            onClick={handleEditBtnClick}
            className="actions__edit flex flex-ai-c"
            data-tool-tip-bottom-right={t("EIDT")}
          >
            <EditIconComponent className="actions__edit__icon" />
          </div>

          <div
            onClick={handleCopyBtnClick}
            className="actions__copy no-margin"
            data-tool-tip-bottom-right={t("COPY")}
          >
            <CopyIconComponent className="actions__copy__icon" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContentField;
